
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { HttpService } from 'src/app/service/http.service';
import { DecryptPipe } from 'src/app/shared/decrypt.pipe';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-auto-login',
  templateUrl: './auto-login.component.html',
  styleUrls: ['./auto-login.component.scss']
})
export class AutoLoginComponent implements OnInit {
  constructor(private router: Router, private httpService: HttpService, private toasterService: ToastrService, private decryptPipe: DecryptPipe) {  }
  ngOnInit(): void {
    try {
      let param = decodeURIComponent(this.router.url.split('autologin?')[1].replace(/\=+/g, ""));
      param = atob(param);
      param = JSON.parse(this.decryptPipe.transform(param));
      if (param && param['token']) {
        this.httpService.localStorageSetItem('admin_token', param['token']);
        this.httpService.getUserInfo(param['user_id'], param['company_id']).subscribe((userData) => {
          if (userData && userData['user']) {
            userData["user"] = JSON.parse(this.httpService.decrypt(userData['user']));
            this.httpService.sessionStorageSetItem('admin_role', userData['user']['role']);
            this.httpService.localStorageSetItem('admin_user', JSON.stringify(userData["user"]));
            this.httpService.localStorageSetItem('company_name',userData['user']['Company']['name']);
            this.httpService.localStorageSetItem('admin_token', userData['accessToken']);
            this.httpService.localStorageSetItem('company_id', param['company_id']);
            this.router.navigate([`/company-dashboard/${param['company_id']}/users`]);
          }
        })
      }
    } catch (error) {
      console.log(error, 'login failed');
      this.toasterService.error('Login Failed, try after sometime.')
    }
  }
}
